import React from 'react';
import getConfig from 'next/config';
import Router from 'next/router';
import { isEmpty } from 'lodash';

import trackEvent from '../../utils/event-helper';
import { getUTMParams } from '../../utils/browser-utils';

import styles from './Social.module.scss';

const { publicRuntimeConfig: { config } } = getConfig();

const Social = ({ style }) => {
  const socialMedia = [
    'google',
  ];

  const generateCallbackUrl = (social) => {
    const callbackUrl = encodeURIComponent(`${config.BASE_URL}`);
    const source = getUTMParams();
    const sourceParam = isEmpty(source) ? '' : `&source=${encodeURIComponent(JSON.stringify(source))}`;
    // Register tab may create an (invited) account; login tab is login-only. The backend
    // rejects a new account unless mode=signup.
    const mode = Router.pathname.includes('signup') ? 'signup' : 'login';

    return `${config.USERS_URL}/auth/${social}?callback=${callbackUrl}${sourceParam}&mode=${mode}`;
  };

  const openSocialSignin = (social) => {
    const page = Router.pathname.includes('signup') ? 'registration' : 'login';
    trackEvent(`user_${page}_${social}_clicked`, { method: social });
    const url = generateCallbackUrl(social);
    window.location.href = url;
  };

  const separator = <div className={styles.separator}></div>;

  return (
        <div style={style}>
            <div className={styles.topPart}>
                {separator}
                <div className={styles.label}>Or continue with</div>
                {separator}
            </div>
            <div className={styles.socialContainer}>
              {socialMedia.map((media) => <div key={media}
                className={styles.icon} onClick={() => openSocialSignin(media)} data-test-id={`auth-${media}`}>
                <div className={styles.overlay} />
                <img src={`/${media}-icon.svg`}/>
            </div>)}
            </div>
        </div>
  );
};

export default Social;
